import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const UsFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" className="rounded-full overflow-hidden shrink-0">
    <mask id="us-mask">
      <circle cx="256" cy="256" r="256" fill="white" />
    </mask>
    <g mask="url(#us-mask)">
      <rect width="512" height="512" fill="#eee" />
      <rect y="46" width="512" height="42" fill="#d80027" />
      <rect y="139" width="512" height="42" fill="#d80027" />
      <rect y="232" width="512" height="42" fill="#d80027" />
      <rect y="325" width="512" height="42" fill="#d80027" />
      <rect y="418" width="512" height="42" fill="#d80027" />
      <rect width="256" height="274" fill="#0052b4" />
      <g fill="#fff">
        <circle cx="43" cy="43" r="14" />
        <circle cx="128" cy="43" r="14" />
        <circle cx="213" cy="43" r="14" />
        <circle cx="85" cy="85" r="14" />
        <circle cx="170" cy="85" r="14" />
        <circle cx="43" cy="128" r="14" />
        <circle cx="128" cy="128" r="14" />
        <circle cx="213" cy="128" r="14" />
        <circle cx="85" cy="170" r="14" />
        <circle cx="170" cy="170" r="14" />
        <circle cx="43" cy="213" r="14" />
        <circle cx="128" cy="213" r="14" />
        <circle cx="213" cy="213" r="14" />
      </g>
    </g>
  </svg>
);

const IdFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" className="rounded-full overflow-hidden shrink-0 border border-black/10 box-border">
    <mask id="id-mask">
      <circle cx="256" cy="256" r="256" fill="white" />
    </mask>
    <g mask="url(#id-mask)">
      <rect width="512" height="256" fill="#d80027" />
      <rect y="256" width="512" height="256" fill="#eee" />
    </g>
  </svg>
);

const UtilityBar = ({ t, lang, setLang, setPage }) => {
  const isEn = lang === 'en';

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY < 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`hidden lg:flex w-full bg-navy text-white/90 text-[13px] fixed top-0 left-0 right-0 z-[60] transition-transform duration-300 ${visible ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="max-w-[1440px] mx-auto  h-12 box-border flex items-center justify-between">

        {/* Left: contact & language switcher */}
        <div className="flex items-center gap-48">
          {/* Contact Info */}
          <div className="flex items-center gap-8">
            <span className="flex items-center gap-2">
              <span className="text-white/60">{t.utilAdm}:</span>
              <span className="font-semibold">+62 811-1180-1448</span>
            </span>
            <span className="flex items-center gap-2">
              <span className="text-white/60">Email:</span>
              <span className="font-semibold">admissions@gmis.sch.id</span>
            </span>
          </div>

          {/* Divider */}
          <div className="h-5 w-px bg-white/20" />

          {/* Language Switcher Dropdown */}
          <div className="flex items-center gap-8">
          <a className="hover:text-gold transition-colors duration-200 font-medium cursor-pointer" onClick={(e) => { e.preventDefault(); if (setPage) setPage('coming-soon'); }}>{t.student}</a>
          <a className="hover:text-gold transition-colors duration-200 font-medium cursor-pointer" onClick={(e) => { e.preventDefault(); if (setPage) setPage('coming-soon'); }}>{t.parent}</a>

        </div>
        </div>

        {/* Right: portals */}
       
         <div className="relative group flex items-center h-12 cursor-pointer ml-12">
            <div className="flex items-center gap-2">
              {isEn ? <UsFlag /> : <IdFlag />}
              <ChevronDown size={14} className="opacity-70 group-hover:opacity-100 transition-opacity" />
            </div>

            {/* Dropdown Menu */}
            <div className="absolute top-12 left-0 w-[160px] bg-white rounded-[6px] shadow-[0_12px_24px_rgba(0,0,0,0.15)] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 flex flex-col py-2 translate-y-2 group-hover:translate-y-0 before:content-[''] before:absolute before:h-4 before:-top-4 before:left-0 before:w-full border border-line">
              <button
                onClick={() => setLang('id')}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-ink hover:bg-paper hover:text-navy transition-colors font-medium text-[14px]"
              >
                <IdFlag />
                Indonesia
              </button>
              <button
                onClick={() => setLang('en')}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-ink hover:bg-paper hover:text-navy transition-colors font-medium text-[14px]"
              >
                <UsFlag />
                English
              </button>
            </div>
          </div>

      </div>
    </div>
  );
};

export default UtilityBar;
